<div class="row narrow-gutters mb-2">
  <div class="col-md-auto ms-auto">
    <span class="btn-group dropup mx-1 always-enabled">
        <button class="btn btn-outline-secondary dropdown-toggle py-1" style="min-width: 7rem" type="button"
                data-bs-toggle="dropdown">Outgoing <span class="caret"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
              <li (click)="toOutgoingMessages()" class="dropdown-item">to Harbour Company</li>
        </ul>
    </span>
  </div>
</div>
